import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import smartMapperApis, {
  ParseResponse,
} from "../../../api/smartMapper/smartMapperApis";

interface SmartMapperAccessState {
  authenticated: boolean;
  clientId?: string;
  agentType?: string;
  loading: boolean;
  verified: boolean;
  error: string | null;
}

const initialState: SmartMapperAccessState = {
  authenticated: false,
  loading: false,
  verified: false,
  error: null,
};

// Called once after a successful login / azure callback to warm up the
// smart-mapper identity. The response tells us whether this tenant has
// the intake_template agent granted — UI uses that flag to show or hide
// the Smart AI Mapper tab in Bulk Material Upload.
export const verifySmartMapperAccess = createAsyncThunk<ParseResponse>(
  "smartMapperAccess/verify",
  async (_, { rejectWithValue }) => {
    try {
      const response = await smartMapperApis.parse();
      return response;
    } catch (err: any) {
      return rejectWithValue(err?.message || "Smart-mapper parse failed");
    }
  }
);

const smartMapperAccessSlice = createSlice({
  name: "smartMapperAccess",
  initialState,
  reducers: {
    resetSmartMapperAccess(state) {
      state.authenticated = false;
      state.clientId = undefined;
      state.agentType = undefined;
      state.loading = false;
      state.verified = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifySmartMapperAccess.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifySmartMapperAccess.fulfilled, (state, action) => {
        const payload = action.payload || ({} as ParseResponse);
        state.loading = false;
        state.verified = true;
        state.authenticated = payload?.status === "authenticated";
        state.clientId = payload?.client_id;
        state.agentType = payload?.agent_type;
      })
      .addCase(verifySmartMapperAccess.rejected, (state, action) => {
        state.loading = false;
        state.verified = true;
        state.authenticated = false;
        state.error =
          (action.payload as string) || "Smart-mapper parse failed";
      });
  },
});

export const { resetSmartMapperAccess } = smartMapperAccessSlice.actions;
export default smartMapperAccessSlice.reducer;
export { smartMapperAccessSlice };
